import React from 'react';
import { TextArea } from '@trackman/web-shared-components';
import { Headline, NoteDescription } from './AddNoteStyles';
import { observer } from 'mobx-react-lite';
import { useInjection } from 'services/ioc/ioc.react';
import { ServiceTypes } from 'constants/ServiceTypes';
import NoteStore from 'stores/NoteStore';

const AddNote = observer(() => {
  const noteStore = useInjection<NoteStore>(ServiceTypes.NoteStore);

  const noteChangeHandler: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> = (event) => {
    noteStore.setNote(event.target.value);
  };

  return (
    <div>
      <Headline>Add note</Headline>
      <NoteDescription>If a note is added, this will be shown on the first non-warmup pitch of the session.</NoteDescription>
      <TextArea value={noteStore.note} onChange={noteChangeHandler} placeholder='Text area label' width={460} />
    </div>
  );
});

export default AddNote;
